import { useListingResults } from 'app/components/listing-results-context';
import { Gradient } from 'app/design/primitives/gradient';
import { Accessory } from 'app/design/primitives/page/accessory';
import type { useScopedTranslation } from 'app/hooks/i18n';
import { Button } from 'app/shopify';
import type React from 'react';
import { View } from 'react-native';
import { theme } from './shared';

export function ListingsSelectionAccessory({
  isSelecting,
  isSmallUI,
  isLargeUI,
  selectedRowsState,
  selectAll,
  t,
  setListingForMenuAction,
  setShowActions,
}: {
  isSelecting: boolean;
  isSmallUI: boolean;
  isLargeUI: boolean;
  selectedRowsState: [string[], React.Dispatch<React.SetStateAction<string[]>>];
  selectAll: boolean;
  t: ReturnType<typeof useScopedTranslation>['t'];
  setListingForMenuAction: React.Dispatch<React.SetStateAction<string | null>>;
  setShowActions: React.Dispatch<React.SetStateAction<boolean>>;
}): React.ReactNode {
  const { isSelectAllPartial, isSelectingAll } = useListingResults();

  return isSelecting && isSmallUI ? (
    <Accessory marginBottom={isLargeUI ? theme.spacing['spacing.general.x2'] : 52}>
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Gradient
          from={theme.colors['surface.default']}
          fromOpacity={0}
          style={{ position: 'absolute', left: 0, right: 0, bottom: -20, height: 60 }}
          to={theme.colors['surface.default']}
        />
        <View style={{ paddingHorizontal: theme.spacing['spacing.general.x4'], width: '100%' }}>
          <Button
            disabled={selectedRowsState[0].length === 0 || (selectAll && isSelectingAll && !isSelectAllPartial)}
            label={t('modifyListingsCountButton', { count: selectedRowsState[0].length })}
            onPress={() => {
              setListingForMenuAction(null);
              setShowActions(true);
            }}
            variant="primary"
          />
        </View>
      </View>
    </Accessory>
  ) : undefined;
}
